module.exports = __webpack_public_path__ + "static/media/policy_settings_document_categories.09ee43fc.svg";